import React from 'react'
import Container from "../componants/Container";
import PaymentsContent from './payments/PaymentsContent'

const Payments = () => {
  return (
    <Container>
      <PaymentsContent />
    </Container>
  )
}

export default Payments